import Cookies from 'js-cookie';
import detectIt from 'detect-it';
import Exitent from 'Exitent';
import parse from 'url-parse';
import SmoothScroll from 'smooth-scroll';
import { debounce, includes, map } from 'lodash';

import accordion from './bush.accordion';
import parallax from './bush.parallax';
import tabs from './bush.tabs';
import mobile_side_nav from './bush.mobile_side_nav';


require('bootstrap-modal-fullscreen');

/**
 * @file
 * Theme hooks for the Bush Foundation Bootstrap child theme.
 */
(($) => {
  $('body').once('bush-theme').each(() => {
    accordion($);
    parallax();
    tabs($);
    mobile_side_nav($);


    $(document).on('keyup', (evt) => {
      if ($(document.body).hasClass('modal-open')) {
        if (evt.keyCode === 27) {
          $('.modal.in').modal('hide');
        }
      }
      return;
    });

    $('.dropdown-menu').on('keyup', (evt) => {
      if (evt.keyCode === 27) {
        $(evt.target).dropdown('toggle');
      }
    });

    $(document).on('hidden.bs.dropdown', (evt) => {
      $(evt.target).find('.dropdown-toggle').focus();
    });

    $('#block-explorebytopic').each(function() {
      var $toggle = $(this);
      $('h2', this).click(function() {
        $('ul.menu',$toggle).slideToggle();
      });

    });

    // Homepage banner animation
    $('.paragraph--type-homepage-banner-carousel .field--name-field-items > div:first-child').addClass('on');
    var count = 0;
    function animateBanner() {
      var items = $('.paragraph--type-homepage-banner-carousel .field--name-field-items > div');
      var itemsLength = items.length - 1;
      //Check if the actual item isn't more than the length then add 1 otherway restart to 0
      count < itemsLength ? count++ : count=0;
      //Remove the class and add it to the new target
      items.removeClass('on').eq(count).addClass('on');
    }
    setInterval(animateBanner, 8000);

    /* global window, document */
    const scrollToHere = document.getElementById('scroll-to-here');
    if (scrollToHere) {
      if (window.location.search) {
        window.scroll = new SmoothScroll();
        window.scroll.animateScroll(scrollToHere, null, {
          offset: () => ($('body').hasClass('adminimal-admin-toolbar') ? 79 : 0),
          speed: 1000,
          updateURL: false,
        });
      }
    }

    // Button handler for most recent search, which is actually just the
    // absence of a location search.
    if (document.getElementById('fellows-location-search')) {
      $('.fellows-most-recent-search').on('click touch', () => {
        const parsedUrl = parse(window.location.href, true);
        delete parsedUrl.query['location[value]'];
        delete parsedUrl.query.page;
        window.location.href = parsedUrl.toString();
      });
    }

    // Anchor links smooth scrolling to position.
    if (document.querySelector('.view-side-anchor-navigation')) {
      $('body').addClass('has-side-nav');
      $('.view-side-anchor-navigation a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 1000, function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                };
              });
            }
          }
        });
        // Add dots for number of charts within anchor section
        $('.view-side-anchor-navigation a[href*="#"]').each(function() {
          var $listItem = $(this).parents('li');
          $listItem.append('<ul></ul>');
          var $id = $(this).attr('href').substr(1);
          // Count the number of chart cards
          var $number = $('a[name="'+$id+'"] ~ .field--name-field-components .wrapper-chart_cards .field--name-field-scorecards > .field--item').length;

          for (var n = 0; n < $number; ++ n) {
            $listItem.find('ul').append('<li></li>');
          }
        });
    }

    // Side Nav fixed
    function fixSectionNav() {
      var $sectionNav = $('.paragraph--type-side-navigation');
      var $sectionInner = $('.paragraph--type-side-navigation > div > .inner');
      if ($(window).scrollTop() > $sectionNav.data('top')) {
        $sectionNav.css({ 'position': 'fixed', 'top': '6rem', 'z-index': '1000' });
        $sectionNav.addClass('fixed').addClass('collapsed');
        $sectionInner.slideUp();
      }
      else {
        $sectionNav.css({ 'position': 'static', 'top': 'auto' });
        $sectionNav.removeClass('fixed').removeClass('collapsed');
        $sectionInner.slideDown();
      }
    }

    if (document.querySelector('.paragraph--type-side-navigation')) {
      $('.paragraph--type-side-navigation').data('top', $('.paragraph--type-side-navigation').offset().top); // set original position on load
      $(window).scroll(fixSectionNav);
    }

  });

  const autosubmitGranteeSort = () => {
    if (!document.getElementById('views-exposed-form-grantees-search-grantees')) return;
    $('#views-exposed-form-grantees-search-grantees [type="radio"]').off('change').on('change', (evt) => {
      const submitButton = document.querySelector('[id^=edit-submit-grantees-search]');
      $(submitButton).click();
    });
  };

  autosubmitGranteeSort();
  $(window).ajaxComplete(autosubmitGranteeSort);

  const opportunityBanner = document.querySelector('.page-node-type-opportunity .region-banner');
  if (opportunityBanner) {
    const $button = $('<div class="print-button-container"></div')
      .html('<button><span class="glyphicon glyphicon-print"></span> Print Page</button>')
      .on('click touch', () => window.print());
    $button.prependTo($('.region-content'));
  }

  // Autostart videos in modals
  const tag = document.createElement('script');
  tag.id = 'iframe-yt-api';
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  window.onYouTubeIframeAPIReady = () => {
    const youtubeContainers = document.querySelectorAll('.field--type-video');
    window.ytPlayers = {};
    map(youtubeContainers, (container) => {
      const modal = $(container).closest('.modal');
      if (modal.length) {
        const { id } = modal[0];
        const iframe = container.querySelector('iframe');
        if (includes(iframe.getAttribute('src'), 'youtube')) {
          /* global YT */
          window.ytPlayers[id] = new YT.Player(iframe, {
            events: {
            },
          });
        }
      }
    });
    const modalToggles = document.querySelectorAll('[data-toggle="modal"]');
    map(modalToggles, (toggle) => {
      /* eslint-disable no-param-reassign */
      toggle.onclick = (evt) => {
        const target = toggle.getAttribute('data-target');
        const $modal = $(target);
        if ($modal.hasClass('is-animating')) {
          evt.stopPropagation();
          return;
        }
        $modal.addClass('is-animating');
        setTimeout(() => $modal.removeClass('is-animating'), 500);
        const id = $modal.attr('id');
        if (window.ytPlayers[id]) {
          // This doesn't work in Chrome anymore :(
          window.ytPlayers[id].playVideo();
        }
      };
    });
    $(document).on('hide.bs.modal', (evt) => {
      const id = $(evt.target).attr('id');
      if (window.ytPlayers[id]) window.ytPlayers[id].pauseVideo();
      if (id === 'main-menu') $('body').removeClass('nav-open');
      window.bsDarkBackdrop = false;
    });

    $('.node--type-scorecard [data-toggle="modal"]').on('click touch', () => {
      window.bsDarkBackdrop = true;
    });

    /* global MutationObserver */
    const backdropObserver = new MutationObserver((mutationsList, observer) => {
      map(mutationsList, (mutation) => {
        map(mutation.addedNodes, (node) => {
          if ($(node).hasClass('modal-backdrop')) {
            if (window.bsDarkBackdrop) {
              node.classList.add('is-dark');
            }
          }
        });
      });
    });

    backdropObserver.observe(
      document.body,
      { childList: true, attributes: false, subtree: false }
    );

    $(document).on('show.bs.modal', (evt) => {
      const id = $(evt.target).attr('id');
      if (id === 'main-menu') {
        $('body').addClass('nav-open');
      }
    });
  };

  if (document.getElementById('block-bmagfeedbacksurvey')) {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    // Attach exit intent listener at a scroll threshhold of 1000 and remove
    // event listener.
    const onExitent = () => {
      $('body').addClass('exit-intent');
      $('#block-bmagfeedbacksurvey button.closex-button').click((e) => {
        e.preventDefault();
        $('#block-bmagfeedbacksurvey').hide();
      });
    };

    if (detectIt.deviceType === 'touchOnly' || vw <= 601) {
      window.maxScrolled = 0;
      window.addEventListener('scroll', debounce(() => {
        const { pageYOffset } = window;
        if (window.maxScrolled < pageYOffset) {
          window.maxScrolled = pageYOffset;
        } else if (window.maxScrolled - pageYOffset > 100) {
          if (!Cookies.get('mobileExitIntentSeen')) {
            onExitent();
            Cookies.set('mobileExitIntentSeen', Date.now(), { expires: 1 });
          }
        }
      }), 100);
    } else {
      const exitAttachListener = window.addEventListener('scroll', () => {
        const { pageYOffset } = window;
        if (pageYOffset > 1000) {
          /* eslint-disable no-new */
          new Exitent({
            checkReferrer: false,
            maxDisplays: 1,
            onExitent,
          });
          window.removeEventListener('scroll', exitAttachListener, false);
        }
      });
    }
  }

  //Alert in view animation
  $(window).on('scroll', function() {
    animateIt();
    animateGraphicsPage();
  });

  function animateIt(){
    $('.paragraph--type-alert, .paragraph--type-quote .field--name-field-text, .view-learning-logs .node--view-mode-teaser').each(function() {
      if (isScrolledIntoView($(this), 1.2)) {
        if (!$(this).hasClass('scrolled')) {
          $(this).addClass('scrolled');
          //$(this).change();
        }
      }
      else {
        if ($(this).hasClass('scrolled')) {
          $(this).removeClass('scrolled');
          //$(this).change();
        }
      }
    });
  }
  animateIt();

  function animateGraphicsPage(){
    $('.onscroll').each(function() {
      if (isScrolledIntoView($(this), 3)) {
        if (!$(this).hasClass('scrolled')) {
          $(this).addClass('scrolled');
          //$(this).change();
        }
      }
      else {
        if ($(this).hasClass('scrolled')) {
          $(this).removeClass('scrolled');
          //$(this).change();
        }
      }
    });
  }

  function isScrolledIntoView(elem, divider) {
    let docViewTop = $(window).scrollTop();
    let threshold = docViewTop + ($(window).height() / divider);
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();
    return (elemTop <= threshold);
  }

})(window.jQuery);
